import { render, staticRenderFns } from "./CopyPublishedUrl.vue?vue&type=template&id=2a511700"
import script from "./CopyPublishedUrl.vue?vue&type=script&lang=js"
export * from "./CopyPublishedUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports